import { StyleSheet } from 'aphrodite';
import { navigation } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	avatar: {
		height: 35,
		marginRight: 10,
		width: 35,
	},
	details: {
		display: 'flex',
		flexDirection: 'column',
		width: 'calc(100% - 50px)',
	},
	email: {
		color: navigation,
		fontSize: 12,
	},
	listItem: {
		alignItems: 'center',
		display: 'flex',
		padding: '10px 20px',
	},
	name: {
		color: '#000000',
		fontSize: 14,
		textDecoration: 'none',
	},
	title: {
		color: navigation,
		fontSize: 12,
		letterSpacing: 0,
	},
});
